import React, { useEffect } from 'react';
import { connect } from 'react-redux';

import PropTypes from 'prop-types';

import { toggleModal, toggleSpinner } from 'apps/auth/actions/appAction';
import { toggleChat } from 'apps/auth/actions/chatAction';
import { DangerouslyHtml } from 'apps/auth/components/common/DangerouslyHtml/DangerouslyHtml';
import { InfoPage } from 'apps/auth/components/common/Layout/InfoPage/InfoPage';
import ModalComponent from 'apps/auth/components/utils/ModalComponent';
import { AUTH_HISTORY_CONFIRM_PLC_TERMS } from 'apps/auth/constants/UrlConstants';
import { apiFetchData } from 'apps/auth/helpers/api';
import { resolveArguments } from 'apps/auth/helpers/utils';

const useLaunchZendeskChatEvent = (toggleChat) => {
    useEffect(() => {
        let chatLink;
        const linkClick = (e) => {
            e.preventDefault();
            toggleChat(true);
        };
        if (__isBrowser__) {
            chatLink = document.querySelector('a[data-action-id="action-zendesk-chat-launch"]');
            if (chatLink) {
                chatLink.addEventListener('click', linkClick);
            }
        }

        return () => {
            if (chatLink) {
                chatLink.removeEventListener('click', linkClick);
            }
        };
    }, [toggleChat]);
};
const TermsDisclaimer = (props) => {
    const arg = [props.userName, props.userLastName];
    const { canCloseModal = false, confirmationPath = '' } = props;

    const confirmUrl = confirmationPath || `${AUTH_HISTORY_CONFIRM_PLC_TERMS}`;

    useLaunchZendeskChatEvent(props.toggleChat);

    const confirm = (e) => {
        e.preventDefault();
        props.toggleSpinner(true);
        apiFetchData(confirmUrl).finally(() => {
            props.closeModalHandler?.();
            props.toggleSpinner(false);
            props.toggleModal(false);
        });
    };

    return (
        <ModalComponent canCloseModal={canCloseModal} isIconClose>
            <InfoPage
                insideModalComponent
                headerText={props.title}
                secondaryText={<DangerouslyHtml dangerouslyHtml={resolveArguments(props.content, arg)} />}
                primaryButtonCaption={props.continueButton}
                primaryButtonOnClick={confirm}
                primaryButtonType="link"
                primaryButtonLink={confirmUrl}
            />
        </ModalComponent>
    );
};

TermsDisclaimer.propTypes = {
    canCloseModal: PropTypes.bool,
    confirmationPath: PropTypes.string,
    continueButton: PropTypes.string,
    userName: PropTypes.string,
    userLastName: PropTypes.string,
    title: PropTypes.string,
    content: PropTypes.string,
    closeModalHandler: PropTypes.func,
};
export default connect(null, { toggleChat, toggleSpinner, toggleModal })(TermsDisclaimer);
